// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var Json_encode = require("@glennsl/bs-json/src/Json_encode.res.js");
var FormField$ReactHooksTemplate = require("../common/FormField.res.js");

function fromId(t) {
  return t.fromId;
}

function empty(param) {
  return {
          id: undefined,
          subject: "",
          body: "",
          emailTemplateId: undefined,
          fromId: undefined
        };
}

function setSubject(x, t) {
  return {
          id: t.id,
          subject: x,
          body: t.body,
          emailTemplateId: t.emailTemplateId,
          fromId: t.fromId
        };
}

function setBody(x, t) {
  return {
          id: t.id,
          subject: t.subject,
          body: x,
          emailTemplateId: t.emailTemplateId,
          fromId: t.fromId
        };
}

function setEmailTemplateId(x, t) {
  return {
          id: t.id,
          subject: t.subject,
          body: t.body,
          emailTemplateId: x,
          fromId: t.fromId
        };
}

function setEmailFromId(x, t) {
  return {
          id: t.id,
          subject: t.subject,
          body: t.body,
          emailTemplateId: t.emailTemplateId,
          fromId: x
        };
}

function validSubject(x) {
  return x !== "";
}

function validBody(x) {
  return x !== "";
}

function validEmailTemplateId(x) {
  return x !== undefined;
}

function toForm(t) {
  return {
          id: {
            TAG: "Valid",
            _0: t.id
          },
          subject: t.subject !== "" ? ({
                TAG: "Valid",
                _0: t.subject
              }) : ({
                TAG: "Invalid",
                _0: t.subject,
                _1: {
                  hd: "can't be empty",
                  tl: /* [] */0
                }
              }),
          body: t.body !== "" ? ({
                TAG: "Valid",
                _0: t.body
              }) : ({
                TAG: "Invalid",
                _0: t.body,
                _1: {
                  hd: "can't be empty",
                  tl: /* [] */0
                }
              }),
          emailTemplateId: validEmailTemplateId(t.emailTemplateId) ? ({
                TAG: "Valid",
                _0: t.emailTemplateId
              }) : ({
                TAG: "Invalid",
                _0: t.emailTemplateId,
                _1: {
                  hd: "can't be empty",
                  tl: /* [] */0
                }
              }),
          fromId: {
            TAG: "Valid",
            _0: t.fromId
          }
        };
}

function fromForm(form) {
  return {
          id: FormField$ReactHooksTemplate.getInputValue(form.id),
          subject: FormField$ReactHooksTemplate.getInputValue(form.subject),
          body: FormField$ReactHooksTemplate.getInputValue(form.body),
          emailTemplateId: FormField$ReactHooksTemplate.getInputValue(form.emailTemplateId),
          fromId: FormField$ReactHooksTemplate.getInputValue(form.fromId)
        };
}

function encoder(t) {
  return Json_encode.object_({
              hd: [
                "id",
                Json_encode.nullable((function (prim) {
                        return prim;
                      }), t.id)
              ],
              tl: {
                hd: [
                  "subject",
                  t.subject
                ],
                tl: {
                  hd: [
                    "body",
                    t.body
                  ],
                  tl: {
                    hd: [
                      "email_template_id",
                      Json_encode.nullable((function (prim) {
                              return prim;
                            }), t.emailTemplateId)
                    ],
                    tl: {
                      hd: [
                        "from_id",
                        Json_encode.nullable((function (prim) {
                                return prim;
                              }), t.fromId)
                      ],
                      tl: /* [] */0
                    }
                  }
                }
              }
            });
}

function decoder(json) {
  return {
          id: Json_decode.optional((function (param) {
                  return Json_decode.field("id", Json_decode.$$int, param);
                }), json),
          subject: Json_decode.field("subject", Json_decode.string, json),
          body: Json_decode.field("body", Json_decode.string, json),
          emailTemplateId: Json_decode.optional((function (param) {
                  return Json_decode.field("email_template_id", Json_decode.$$int, param);
                }), json),
          fromId: Json_decode.optional((function (param) {
                  return Json_decode.field("from_id", Json_decode.$$int, param);
                }), json)
        };
}

var modeType = "Email";

exports.modeType = modeType;
exports.fromId = fromId;
exports.empty = empty;
exports.setSubject = setSubject;
exports.setBody = setBody;
exports.setEmailTemplateId = setEmailTemplateId;
exports.setEmailFromId = setEmailFromId;
exports.validSubject = validSubject;
exports.validBody = validBody;
exports.validEmailTemplateId = validEmailTemplateId;
exports.toForm = toForm;
exports.fromForm = fromForm;
exports.encoder = encoder;
exports.decoder = decoder;
/* No side effect */
